export default "__VITE_ASSET__qOh4SFqu__"